import CustomEditor from "components/Common/CustomEditor"
import React, { useEffect, useState, useRef, useMemo } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"

import { Typography } from "antd"
import moment from "moment"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import { fixedIds } from "app_config"

const { Title } = Typography

import { stopTimer } from "store/timer/actions"
import { useDispatch } from "react-redux"

const AddHoursTime = ({
  show,
  setShow,
  ids,
  setLogsData = false,
  setTaskData = false,
  setAllTasks = false,
  setLogsPopup = () => {},
}) => {
  // ===============
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  // const [workingHour, setWorkingHour] = useState("00:00")
  const [totalHours, setTotalHours] = useState("0.00")
  const [currDate, setCurrDate] = useState("")
  const [isManualLog, setIsManualLog] = useState(false)

  const [workType, setWorkType] = useState(null)
  const [attachment, setattachment] = useState(null)
  const [work_type_options, setwork_type_options] = useState([])
  const [status_options, setstatus_options] = useState([])
  const [status, setStatus] = useState(null)
  const [statusStyle, setStatusStyle] = useState({})
  const [description, setDescription] = useState("")

  const [editReason, setEditReason] = useState("")
  const [manualTitle, setManualTitle] = useState("")
  const [copy_to_note, setcopy_to_note] = useState(false)
  const [copy_to_client_note, setcopy_to_client_note] = useState(false)
  const [fileUrl, setFileUrl] = useState(null)
  const [designations, setdesignations] = useState([])

  const [loading, setLoading] = useState(false)

  const fileRef = useRef()
  const dispatch = useDispatch()

  const filteredStatusOptions = useMemo(() => {
    if (!ids?.service) {
      return status_options
    }

    const taskServiceId = Number(ids.service)

    return status_options
      .filter(sts => {
        if (!sts.serviceIds || !Array.isArray(sts.serviceIds)) return false
        return sts.serviceIds.some(id => Number(id) === taskServiceId)
      })
      .sort((a, b) => a.statusName.localeCompare(b.statusName))
  }, [status_options, ids?.service])

  // getting existing data in case of edit
  useEffect(() => {
    if (ids?.logId) {
      ;(async () => {
        let { data } = await axiosbaseurl.get(`/task-updates/log/${ids?.logId}`)
        if (data) {
          const {
            startTime,
            endTime,
            createdAt,
            workTypeId,
            statusId,
            workDescription,
            editReason,
            taskLogDocument,
            title,
          } = data.data

          setStartTime(startTime)

          if (title) {
            setIsManualLog(true)
            setManualTitle(title)
          }

          if (data?.employeeDesignation) {
            setdesignations(JSON.parse(data?.employeeDesignation))
          }

          if (ids?.stopingTimer) {
            setEndTime(moment().format("HH:mm"))
          } else setEndTime(endTime)

          setCurrDate(moment(createdAt).format("DD-MM-YYYY"))

          // setTotalHours(workTypeId)
          setWorkType(workTypeId)
          setStatus(statusId)
          setDescription(workDescription)
          setEditReason(editReason)
          if (taskLogDocument)
            setFileUrl(`${process.env.REACT_APP_IMAGE_PATH}/${taskLogDocument}`)
        }
      })()
    }
  }, [ids])

  // reset states
  useEffect(() => {
    if (!show) {
      setStartTime("")
      setEndTime("")
      setTotalHours("0.00")
      setCurrDate("")
      setWorkType(null)
      setattachment(null)
      setStatus(null)
      setStatusStyle({})
      setDescription("")
      setEditReason("")
      setcopy_to_note(false)
      setcopy_to_client_note(false)
      setdesignations([])
      setIsManualLog(false)

      if (fileRef.current) fileRef.current.value = ""
    }
  }, [show])

  // getting datas for dropdowns
  useEffect(() => {
    ;(async () => {
      try {
        let response = await axiosbaseurl.get(`/work-type/active`)
        if (response.data.success) setwork_type_options(response.data.data)

        response = await axiosbaseurl.get(`/status-master/active`)
        if (response.data.success)
          setstatus_options(
            response.data.data?.sort((a, b) => a.sortOrder - b.sortOrder)
          )
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  // status dropdown color changing
  useEffect(() => {
    // set status style
    if (status) {
      const colorCode = status_options?.find(
        item => item.id === Number(status)
      )?.colorCode
      setStatusStyle({ backgroundColor: colorCode, color: "#fff" })
    } else setStatusStyle({})
  }, [status])

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()

    if (ids?.adminView) return

    if (totalHours == "00:00") {
      swal("Insufficient Total Time", "Mininum one minute expected", "warning")
      return
    }

    const formData = new FormData()

    formData.append("taskId", ids.task)
    formData.append("workTypeId", workType)
    formData.append("statusId", status)
    formData.append("startTime", startTime)
    formData.append("endTime", endTime)
    // formData.append("workDescription", description)
    formData.append("copyToWorkNote", copy_to_note ? 1 : 0)
    formData.append("copyToClientNote", copy_to_client_note ? 1 : 0)
    formData.append("clientId", ids.client)
    formData.append("editReason", editReason)
    formData.append("taskLogDocument", attachment)
    if (isManualLog) formData.append("title", manualTitle)

    try {
      setLoading(true)

      let response

      if (ids?.logId)
        response = await axiosbaseurl.put(
          `/task-updates/${ids?.logId}`,
          formData
        )
      else response = await axiosbaseurl.post("/task-updates", formData)

      if (response.data.success) {
        if (setTaskData) {
          if (status == fixedIds.HMRCStatus) {
            // in case of hmrc status
            setTaskData(prev => prev.filter(task => task.id != ids.task))

            if (setAllTasks) {
              setAllTasks(prev => prev.filter(task => task.id != ids.task))
            }
          } else {
            setTaskData(prev => {
              return prev?.map(task => {
                if (ids?.task === task.id) {
                  if (response.data.isTaskStatusUpdate)
                    task.status = status_options?.find(i => i.id == status)
                  task.timer = false
                  task.logId = null
                }
                return task
              })
            })
          }
        }

        if (ids?.logId) {
          if (setLogsData) {
            setLogsData(prev => {
              return prev.map(log => {
                if (ids?.logId === log.id) {
                  log.status = status_options?.find(i => i.id == status)
                }
                return log
              })
            })
          }

          setLogsPopup(false)
        }

        swal("", `Report Saved successfully.`, "success")
        setShow(false)
        dispatch(stopTimer())
      }
    } catch (error) {
      console.log(error)
      const msg =
        error.response.data.message || error.message || "Something went Wrong"

      swal(
        "",
        msg,
        msg.includes("No changes were made !") ? "warning" : "error"
      )
    } finally {
      setLoading(false)
    }
  }

  // calculating total hours based on start & end times
  useEffect(() => {
    const calculateTotalTime = () => {
      const startMoment = moment(startTime, "HH:mm")
      const endMoment = moment(endTime, "HH:mm")

      // If the end time is before the start time, it means the end time is on the next day
      if (endMoment.isBefore(startMoment)) {
        endMoment.add(1, "days") // Add one day to the end time
      }

      // Calculate the difference in minutes
      const diffInMinutes = endMoment.diff(startMoment, "minutes")

      // Convert the difference to hours and minutes
      const hours = Math.floor(diffInMinutes / 60)
      const minutes = diffInMinutes % 60

      // Set total time in "hh:mm" format
      setTotalHours(
        `${hours < 10 ? "0" + hours : hours}:${
          minutes < 10 ? "0" + minutes : minutes
        }`
      )
    }
    if (startTime && endTime) calculateTotalTime()
  }, [startTime, endTime])

  useEffect(() => {
    setStatus(null)
  }, [ids?.service])

  // designation wise times edit access
  const isAllowedTimeChange =
    designations?.includes("Client Manager") ||
    designations?.includes("Production Manager") ||
    designations?.includes("Administrator")

  return (
    <Modal
      size="xl"
      isOpen={show}
      toggle={() => setShow(!show)}
      centered={true}
    >
      <form onSubmit={handleSubmit} className="modal-content">
        <ModalHeader className="w-100 bg-primary">
          <div className="d-flex align-items-center justify-content-between w-100">
            <h5 className="mb-0 text-white">
              Work Report {ids?.logId && ` (${currDate}) `}
            </h5>
            <div>
              {!ids?.adminView && (
                <LoadingButton loading={loading} btn="light" />
              )}
              <button
                type="button"
                className="btn btn-danger ms-3"
                onClick={() => setShow(!show)}
              >
                <i className="fa fa-times me-2"></i> Close
              </button>
              {/* <button type="button" className="btn-close"></button> */}
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="px-3 ">
          {/* <form onSubmit={(e) => e.preventDefault()} > */}

          <div className="d-flex align-items-center border-bottom  mb-3">
            {/* <div className='mb-4 me-5'>
                                <button type='button' className={`btn btn-${planType === 1 ? "primary" : 'light'} me-3`} onClick={() => setPlanType(1)} > Daily</button>

                                <button type='button' className={`btn btn-${planType === 2 ? "primary" : 'light'}`} onClick={() => setPlanType(2)}> Weekly</button>
                            </div> */}
            <div>
              <div className="fs-5 mb-3 d-flex ">
                <div>
                  <strong>Client Name</strong> :{" "}
                  {ids?.clientName && ` ${ids?.clientName} `}
                </div>
                {ids?.taskName && (
                  <div className="ms-4">
                    <strong>Task Name</strong> :{" "}
                    {ids?.taskName ? ` ${ids?.taskName} ` : "N/A"}
                  </div>
                )}
              </div>
            </div>
          </div>
          <>
            <div className="row">
              {ids?.adminEdit ? (
                <div className="col-12">
                  <div className="mb-3">
                    <label>
                      Write reason for this update.{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      value={editReason}
                      onChange={e => {
                        setEditReason(e.target.value)
                      }}
                      className="form-control input-field"
                      placeholder="Write reason here.."
                      minLength={10}
                      required
                    />
                  </div>
                </div>
              ) : null}
              {ids?.adminView && editReason && editReason !== "null" ? (
                <div className="mb-3">
                  <label htmlFor="">Edit Reason</label>
                  <div className="form-control input-field view-field ">
                    {editReason}
                  </div>
                </div>
              ) : null}

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Start Time <span className="text-danger">*</span>
                  </label>

                  <input
                    type="time"
                    value={startTime}
                    onChange={e => {
                      setStartTime(e.target.value)
                    }}
                    className="form-control input-field"
                    // disabled={ids?.adminView}
                    disabled={!isAllowedTimeChange}
                    required
                  />
                  {/* <TimePicker
                                                    value={startTime}
                                                    onChange={handleStartTimeChange}
                                                    format="HH:mm"
                                                    style={{ width: "100%" }}
                                                    className='py-2 input-field'
                                                /> */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    End Time <span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    value={endTime}
                    onChange={e => {
                      setEndTime(e.target.value)
                    }}
                    className="form-control input-field"
                    // disabled={ids?.adminView}
                    disabled={!isAllowedTimeChange}
                    required
                  />
                  {/* <TimePicker
                                                    value={endTime}
                                                    onChange={handleEndTimeChange}
                                                    format="HH:mm"
                                                    style={{ width: "100%" }}
                                                    className='py-2 input-field'
                                                /> */}
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <div>
                    <div>
                      <Title level={5}>Total's Hours </Title>
                      {totalHours && (
                        <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                          {totalHours} {totalHours > 1 ? "s" : ""}
                          <sub className="fw-light fs-6">hrs</sub>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label>
                  Work Type <span className="text-danger">*</span>
                </label>
                <select
                  value={workType}
                  onChange={e => setWorkType(e.target.value)}
                  className="form-select input-field"
                  disabled={ids?.adminView}
                  required
                >
                  <option value="">Select Work Type</option>
                  {work_type_options
                    ?.slice()
                    .sort((a, b) => a.workType.localeCompare(b.workType))
                    ?.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.workType}
                      </option>
                    ))}
                </select>
                {/* <span className="error">{errors.clientType}</span> */}
              </div>
              {!isManualLog ? (
                <>
                  <div className="col-md-4 mb-3">
                    <label>
                      {" "}
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      value={status}
                      onChange={e => setStatus(e.target.value)}
                      style={statusStyle}
                      className="form-select input-field status_select_dropdown"
                      disabled={ids?.adminView}
                      required
                    >
                      <option value="">Select </option>
                      {filteredStatusOptions
                        ?.slice()
                        .sort((a, b) =>
                          a.statusName.localeCompare(b.statusName)
                        )
                        ?.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.statusName}
                          </option>
                        ))}
                    </select>
                    {/* <span className="error">{errors.clientType}</span> */}
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="d-flex justify-content-between">
                      <label>
                        Attachment
                        {/* {!fileUrl && <span className="text-danger">*</span>} */}
                      </label>
                      <div>
                        {fileUrl && (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="fw-semibold"
                          >
                            View Document
                          </a>
                        )}
                      </div>
                    </div>
                    <input
                      type="file"
                      className="form-control input-field"
                      disabled={ids?.adminView}
                      ref={fileRef}
                      onChange={e => setattachment(e.target.files[0])}
                    />
                    {/* <span className="error">{errors.clientType}</span> */}
                  </div>
                </>
              ) : null}

              {/* <div className="col-md-12 my-4"> */}
              <div className=" ">
                {/* <div className="d-flex align-items-center justify-content-between mb-2">
                  <label>
                    Describe today's work
                    <span className="text-danger">*</span>
                  </label>
                  {!isManualLog ? (
                    <div className="d-flex align-items-center justify-content-between ">
                      <div>
                        <div className="d-flex align-items-center">
                          <div className="form-check form-switch form-switch-md ps-0 pe-2">
                            <input
                              type="checkbox"
                              className={`form-check-input my-1 fs-2 ms-0 `}
                              checked={copy_to_client_note}
                              onChange={e =>
                                setcopy_to_client_note(e.target.checked)
                              }
                              disabled={ids?.adminView}
                            />
                          </div>
                          <strong>Copy to client note</strong>
                        </div>
                      </div>
                      <div>
                        <div className="d-flex align-items-center ms-5">
                          <div className="form-check form-switch form-switch-md ps-0 pe-2">
                            <input
                              type="checkbox"
                              className={`form-check-input my-1 fs-2 ms-0 `}
                              checked={copy_to_note}
                              onChange={e => setcopy_to_note(e.target.checked)}
                              disabled={ids?.adminView}
                            />
                          </div>
                          <strong>Copy to work note</strong>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div> */}
                {/* <textarea className='form-control input-field' placeholder='describe here..' rows={5}></textarea> */}
                {/* <CustomEditor
                  content={description}
                  setContent={setDescription}
                  readOnly={ids?.adminView || false}
                /> */}
                {/* <span className="error">{errors.description}</span> */}
              </div>
            </div>
          </>

          {/* {
                            planType === 2 &&
                            <WeeklySheet />
                        } */}

          {/* </form> */}
        </ModalBody>
      </form>
    </Modal>
  )
}

export default AddHoursTime
